import type { Product } from '@mc/api'
import {
  EventTypes as CoreEventTypes,
  trackGoldStandardEvent,
} from '@mc/track-event'
import {
  ActionTypes,
  KeyTypes,
  getTrackedId,
  saveUserData,
} from '@mc/user-data'
import { setMetaProductIdCookie } from 'libs/cookies/metaProductIdCookie'

export const trackGiftProductViewed = (
  annualPass: Product,
  name = 'Annual Membership',
) => {
  // Hardcoded to 1 per requirement: https://ourmasterclass.slack.com/archives/C0B7NBF49BK/p1780431143091789?thread_ts=1780364736.633349&cid=C0B7NBF49BK
  const giftProductId = getTrackedId({ key: KeyTypes.GIFT, id: 1 })

  trackGoldStandardEvent(CoreEventTypes.PRODUCT_VIEWED_GOLD_STANDARD, {
    content_type: 'product',
    name,
    product_id: giftProductId,
    price: annualPass?.productLtv?.regular,
    quantity: 1,
    category: '0',
    currency: annualPass?.pricing?.currency,
  })

  saveUserData({
    key: KeyTypes.GIFT,
    id: giftProductId,
    actionType: ActionTypes.BROWSING,
    eventName: CoreEventTypes.PRODUCT_VIEWED_GOLD_STANDARD,
  })

  setMetaProductIdCookie(giftProductId)
}
